/**
 * @file コンポーネント：フル動画ページタイムラインイベント スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledEvent = styled.div``;

export const StyledEventText = styled.div`
    color: #ffffff;
    font-size: 11px;
    line-height: 16px;
`;

export const StyledEventTime = styled.div`
    margin-bottom: 8px;
    color: #7f97f8;
    font-weight: bold;
    font-size: 11px;
    line-height: 16px;
`;
